import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { FaTrash } from 'react-icons/fa';
import { Button, Table } from 'reactstrap'
import Swal from 'sweetalert2';

function NewsList() {
  const [newsList, setNewsList] = useState([]);

  const getAllLIst = async () => {
    const res = axios.get(`https://ngt.botberries.com/addnews/list`)
    setNewsList((await res).data.result)
  }

  const deleteList = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`https://ngt.botberries.com/addnews/delete`, data)
        setTimeout(() => {
          getAllLIst();
        }, 1000);
      }
    });
  }
  useEffect(() => {
    getAllLIst();
  }, [])
  return (
    <div>
      <div>
        <h3>News List</h3>
        <div>
          <Table>
            <thead>
              <tr>
                <td>Sl</td>
                <td>Subject</td>
                <td>Message </td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {newsList.length > 0 &&
                <>
                  {newsList.map((list, i) => (
                    <tr key={i}>
                      <td>{i + 1} </td>
                      <td>{list.subject} </td>
                      <td>{list.body} </td>
                      <td>
                        <Button color='danger' onClick={() => { deleteList(list) }}>
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </>
              }
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default NewsList